module.exports = __webpack_public_path__ + "img/cert_temp_1.c474d2ba.png";